// EquaOS module allocation — grounded in ThriveTogether/DPS-Blueprint docs/modules/README.md (24 Sep 2026 read)
// icon: Phosphor Duotone name (iconify "ph-duotone:<name>"). status: live | building | not-started | disputed
export const MODULE_GROUPS = [
  { label: 'People', items: [
    { code: 'HIR', name: 'Hiring', icon: 'briefcase', status: 'live', note: 'Live 5 Sep 2026' },
    { code: 'PPL', name: 'Employees', icon: 'identification-badge', status: 'live', note: 'Shared system' },
  ]},
  { label: 'Students & learning', items: [
    { code: 'STU', name: 'Students', icon: 'graduation-cap', status: 'not-started', note: 'The M2 blocker' },
    { code: 'EXM', name: 'Exams', icon: 'clipboard-text', status: 'not-started', note: 'M3' },
    { code: 'LRN', name: 'Learning', icon: 'book-open-text', status: 'not-started', note: 'M4 · Classroom cutover April' },
    { code: 'ALU', name: 'Alumni', icon: 'users-three', status: 'not-started', note: 'M4' },
  ]},
  { label: 'Admissions', items: [
    { code: 'VIS', name: 'Visits', icon: 'map-pin-area', status: 'live', note: 'Smart Campus Visit · base delivered' },
    { code: 'ADM', name: 'Admissions', icon: 'door-open', status: 'not-started', note: 'M3' },
  ]},
  { label: 'Money', items: [
    { code: 'FEE', name: 'Fees', icon: 'wallet', status: 'building', note: 'Ledger built and tested · M3' },
    { code: 'FIN', name: 'Finance', icon: 'chart-line-up', status: 'not-started', note: 'M4' },
    { code: 'PAY', name: 'Payroll', icon: 'money', status: 'not-started', note: 'M4' },
    { code: 'PMT', name: 'Payments', icon: 'credit-card', status: 'building', note: 'Shared · no provider connected yet' },
  ]},
  { label: 'Communication', items: [
    { code: 'MSG', name: 'Messages', icon: 'chat-circle-text', status: 'building', note: 'Shared · M2' },
  ]},
  { label: 'Operations', items: [
    { code: 'TRN', name: 'Transport', icon: 'bus', status: 'disputed', note: 'Milestone disputed · M4' },
    { code: 'FAC', name: 'Facilities', icon: 'wrench', status: 'not-started', note: 'M2' },
    { code: 'SUP', name: 'Supplies', icon: 'package', status: 'not-started', note: 'M2 · naming open ("Stores")' },
    { code: 'VEN', name: 'Vendors', icon: 'handshake', status: 'not-started', note: 'M3' },
    { code: 'GAT', name: 'Gate & security', icon: 'shield-check', status: 'not-started', note: 'M3 · added 15 Sep after review' },
  ]},
  { label: 'Support', items: [
    { code: 'LIB', name: 'Library', icon: 'books', status: 'not-started', note: 'M3' },
    { code: 'HLT', name: 'Health', icon: 'heart-straight', status: 'not-started', note: 'M3 · sensitive category' },
    { code: 'EVT', name: 'Events', icon: 'calendar-star', status: 'not-started', note: 'M4' },
    { code: 'ITA', name: 'IT Assets', icon: 'desktop', status: 'not-started', note: 'M2' },
    { code: 'CAN', name: 'Canteen', icon: 'bowl-food', status: 'not-started', note: 'M4' },
  ]},
  { label: 'Service', items: [
    { code: 'TKT', name: 'Ticketing', icon: 'ticket', status: 'not-started', note: 'M3 · one inbox for every "I need help"' },
    { code: 'FDB', name: 'Feedback', icon: 'thumbs-up', status: 'not-started', note: 'M3' },
    { code: 'FRM', name: 'Forms', icon: 'list-checks', status: 'not-started', note: 'M3 · scope to pin down' },
  ]},
  { label: 'Add-on', items: [
    { code: 'HOS', name: 'Hostel', icon: 'bed', status: 'not-started', note: 'Critical path if a wave-1 campus runs one' },
  ]},
  { label: 'Surfaces', items: [
    { code: 'PAR', name: 'Equall for Parents', icon: 'house-line', status: 'building', note: 'M2 · depends on Students' },
    { code: 'INS', name: 'Insights', icon: 'chart-bar', status: 'live', note: 'Digests + MCP connector live · M4' },
  ]},
  { label: 'Shared systems', items: [
    { code: 'AUT', name: 'Authentication', icon: 'lock-key', status: 'building', note: 'Live for staff · parent sign-in not yet' },
    { code: 'DOC', name: 'Documents', icon: 'file-text', status: 'building', note: 'M2 · named owner 15 Sep 2026' },
  ]},
];

export const STATUS_TONE = { live: 'success', building: 'warning', 'not-started': 'neutral', disputed: 'danger' };
export const STATUS_LABEL = { live: 'Live', building: 'Being built', 'not-started': 'Not started', disputed: 'Disputed' };
